<template>
    <div>
        <div class="background">
            <div style="text-align:center;">
                <img src="../../assets/picture/miaosha/miaosha.png" alt="" style="margin-top:20px;">
            </div>
        </div>
        <div id="content" class="w">
            <div>
                <el-tabs v-model="activeName" @tab-click="handleClick">
                    <el-tab-pane label="限时秒杀" name="first">
                        <pc-miaosha></pc-miaosha>
                    </el-tab-pane>
                    <el-tab-pane label="每日特价" name="second">
                        <pc-tejia></pc-tejia>
                    </el-tab-pane>
                </el-tabs>
            </div>
            
        </div>
    </div>
</template>

<script>
import Pc_miaosha from "./miaosha.vue"
import Pc_tejia from "./tejia.vue"
export default {
    components:{
        "pc-miaosha" : Pc_miaosha,
        "pc-tejia" : Pc_tejia,
    },
    data() {
        return {
            activeName: 'first'
        };
    },
    methods: {
        handleClick(tab, event) {
            console.log(tab, event);
        }
    }
};
</script>

<style scoped>
.background{
    background:url(../../assets/picture/miaosha/header_bgV2.png) no-repeat;
    height:150px;
}
</style>


// WEBPACK FOOTER //
// src/components/pintuan/Index.vue